import { compose } from 'redux';
import { offerService } from 'modules/shared/services/API/backend/offer-service';
import { EventType, GetEventType, Offer, GetOffer, LightStore } from 'modules/shared/models';
import { WithStatelessDatasFetching, WithStatelessDatasFetchingByParameters } from 'modules/shared/hocs';
import { eventTypeService, storeService } from 'modules/shared/services/API/backend';
import { IdentificationFormInjectedProps, IdentificationFormOwnProps } from './identification-form-type';

const enhancer = compose<React.ComponentType<GetEventType & IdentificationFormOwnProps>>(
    WithStatelessDatasFetchingByParameters<EventType[], IdentificationFormInjectedProps, GetEventType>(
        eventTypeService.getByUniverse,
        undefined,
        'error',
        'eventTypes',
        ['universeId', 'hasOrganiser'],
    ),
    WithStatelessDatasFetching<LightStore[], IdentificationFormInjectedProps>(
        storeService.getAll,
        undefined,
        'error',
        'stores',
    ),
    WithStatelessDatasFetchingByParameters<Offer, IdentificationFormInjectedProps, GetOffer>(
        offerService.getCurrentByUniverse,
        undefined,
        'error',
        'offer',
        ['universeId'],
    ),
);

export default enhancer;
